import React from 'react';

import { Card, Input, Select, Text, InputAddress } from 'v3/components';
import { usePreLoad } from '../context';
import { Col, Row } from 'react-bootstrap';
import { useEffectThrottled } from 'hooks';
import moment from 'moment';
import { validateDateTime } from 'v3/utils/functions';
import { fetchByCityAndProvince } from 'utils/fetches';

export function OriginData() {
  const {
    data,
    setData,
    snackbar,
    errors,
    countryOptions,
    setErrors,
    loading,
    loadingDuplicate,
  } = usePreLoad();

  useEffectThrottled(
    () => {
      const origin = moment(data?.origin?.date);
      const isBeforeThanNow = origin.isBefore(moment());

      if (isBeforeThanNow) {
        snackbar.show(
          <Text>Esta carga não aparecerá no aplicativo pois a hora da coleta já passou.</Text>,
          {
            type: 'error',
          },
        );
      }
    },
    [data?.origin?.date],
    2000,
  );

  async function setOriginCity(city) {
    let cityModel = city;
    setData(old => ({
      ...old,
      origin: {
        ...old.origin,
        lng: city?.lng,
        lat: city?.lat,
        city: city?.name,
        cityModel,
        province: cityModel?.province?.uf || '',
      },
    }));
  }

  return (
    <Card
      header={
        <Text color="#464E5F" type="header">
          Origem
        </Text>
      }
      bodyCardPadding="1rem 3rem"
    >
      <Row className="form">
        <Col md={12} xs={12} className="m-0 p-0">
          <Col md={4} xs={12} className="m-0 p-1">
            <Select
              label="País *"
              options={countryOptions}
              value={data.origin?.country}
              isDisabled={loading || loadingDuplicate}
              onChange={value => {
                setData(old => ({
                  ...old,
                  origin: {
                    ...old.origin,
                    country: value,
                    countrySlug: value?.abbreviation,
                    address: '',
                    neighborhood: '',
                    lat: '',
                    lng: '',
                    city: '',
                    cityModel: null,
                    province: '',
                  },
                }));
              }}
              getOptionLabel={option => option.name}
              getOptionValue={option => option.id}
              error={errors[`origin.country`]}
            />
          </Col>
        </Col>

        <Col md={6} xs={12} className="my-3">
          <InputAddress
            label="Cidade *"
            typesRestriction={['(cities)']}
            country={data?.origin?.country?.abbreviation}
            value={data.origin?.city || data.origin?.cityModel?.name || ''}
            disabled={loading || loadingDuplicate}
            onSelectedAddress={async place => {
              const [city] = await fetchByCityAndProvince(
                place.city,
                place.province
              );
              setOriginCity({
                id: city?.id,
                lat: place?.lat,
                lng: place?.lng,
                name: city?.name || place?.name,
                province: city?.province || place?.province,
              });
            }}
            error={errors[`origin.cityModel`]}
          />
        </Col>

        <Col md={4} className="my-3">
          <Input
            label="UF *"
            disabled={true}
            value={data.origin?.province}
            onChange={(event) =>
              setData((old) => ({
                ...old,
                origin: {
                  ...old.origin,
                  province: event.target.value,
                },
              }))
            }
            error={errors[`origin.province`]}
          />
        </Col>

        <Col md={4}>
          <Input
            type="datetime-local"
            value={data.origin?.startSchedule}
            label="Data Inicial *"
            disabled={loading || loadingDuplicate}
            onChange={event => {
              let isValid = validateDateTime(event?.target?.value);
              if (isValid) {
                setData((old) => ({
                  ...old,
                  origin: {
                    ...old.origin,
                    startSchedule: event?.target?.value,
                  },
                }));
                setErrors((old) => ({ ...old, 'origin.startSchedule': null }));
              } else {
                setErrors((old) => ({
                  ...old,
                  'origin.startSchedule': 'Data inválida',
                }));
                setData((old) => ({
                  ...old,
                  origin: {
                    ...old.origin,
                    startSchedule: event?.target?.value,
                  },
                }));
              }
            }}
            error={errors[`origin.startSchedule`] || errors.origin}
          />
        </Col>

        <Col md={4}>
          <Input
            type="datetime-local"
            label="Data Final *"
            value={data.origin?.date}
            disabled={loading || loadingDuplicate}
            onChange={event => {
              let isValid = validateDateTime(event?.target?.value);
              if (isValid) {
                setData((old) => ({
                  ...old,
                  origin: {
                    ...old.origin,
                    date: event?.target?.value,
                  },
                }));
                setErrors((old) => ({ ...old, 'origin.date': null }));
              } else {
                setErrors((old) => ({
                  ...old,
                  'origin.date': 'Data inválida',
                }));
                setData((old) => ({
                  ...old,
                  origin: {
                    ...old.origin,
                    date: event?.target?.value,
                  },
                }));
              }
            }}
            error={errors[`origin.date`]}
          />
        </Col>
      </Row>
    </Card>
  );
}
